<template>
  <div name="TreePage" v-loading="leftLoading">
    <el-tree 
        :data="leftTreeData" 
        :props="leftTreeDefaultProps" 
        @node-click="treeNodeClick"
        @check="treeBoxClick"
        :filter-node-method="filterNode"
        :default-expand-all="leftTreeIfOpen"
        :show-checkbox="dataMaxNumber==1?false:true"
        :check-strictly="ifChooseChild==1?false:true"
        node-key="id"
        highlight-current
        ref="oneTree"
    >

    </el-tree>
    <el-input
        placeholder="输入关键字进行过滤"
        v-model="filterText">
    </el-input>
    <el-button-group>
        <el-button type="primary" icon="el-icon-refresh" @click="treeGetData"></el-button>
        <el-button type="primary" icon="el-icon-circle-plus" @click="leftTreeOpen"></el-button>
        <el-button type="primary" icon="el-icon-remove" @click="leftTreeClose"></el-button>
    </el-button-group>
  </div>
</template>

<script>
import utils from '@/js/page/pageUtil.js'

export default {
  name: 'TreePage',
  data(){
      return{
        leftLoading:false,
        //树形结构是否展开
        leftTreeIfOpen:false,
        //树形结构的数据
        leftTreeData:[],
        //树形结构的展示字段名称设置
        leftTreeDefaultProps:{
            children: 'children',
            label: 'name'
        },
        //树形结构的搜索框的搜索值
        filterText:"",
        //当前点击过的值
        nowCheckOneId:0
      }
  },
  props: {
      /**
       * 下拉树的页面id
       */
      leftTreePageId:Number,
      /**
       * 下拉树的tableId
       */
      leftTreeTableId:Number,
      /**
       * 下拉树选中时 需要回调显示的字段的下标(是第几个字段)
       */
      parentFieldIndex:Number,
      /**
       * 树类型 0：左侧树  1：下拉树
       */
      treeType:String,
      /**
       * 树的最大可选中个数
       */
      dataMaxNumber:String,
      /**
       * 是否父子级关联选中 默认为是
       */
      ifChooseChild:Number,
      /**
       * 树加载数据时，需要进行的后台过滤
       */
      tmpJsonData:String,
      /**
       * 树初始加载时需要选中的值
       */
      initCheckKeyId:String
  },
  methods:{
    /**
     * 左侧树点击时去后台进行数据搜索
     */
    treeNodeClick(data,node,tree){
        console.log(data);
        console.log(node);
        console.log(tree);
        console.log(this.treeType);
        if(this.treeType == 0) {
            //左侧树点击时触发父级的列表搜索按钮
            this.nowCheckOneId = data.id;
            console.log(this.nowCheckOneId);
            //调用父级的列表搜索方法
            this.$emit('initSearchData');
        } else if(this.treeType == 1) {
            //下拉树点击时触发树的选中回调
            var dataArr = [data];
            this.$emit('treeOrDialogCheckCallBack',this.parentFieldIndex,dataArr,1);
            //隐藏树的显示 
            this.$emit('openTree');
        }
    },
    treeBoxClick(node,checkNode) {
        console.log(node);
        console.log(checkNode);
        //checkedNodes 
        //判断是否 已经达到要求选择的个数 如果大于要求选择个数
        if(checkNode.checkedKeys.length > this.dataMaxNumber && this.dataMaxNumber > 0) {
            this.$message({
                message: '最多可以选中'+this.dataMaxNumber+"个!",
                type: 'warning'
            });
            var nowCheckedKeys = checkNode.checkedKeys;
            console.log(nowCheckedKeys);
            nowCheckedKeys.splice(nowCheckedKeys.length-1);
            console.log(nowCheckedKeys);
            console.log(this.$refs);
            this.$refs.oneTree.setCheckedKeys([]);
        } else {
            console.log("=============================================================="+checkNode.checkedNodes);
            this.$emit('treeOrDialogCheckCallBack',this.parentFieldIndex,checkNode.checkedNodes,1);
        }
    },
    /**
     * 加载树形结构的后台数据
     */
    treeGetData() {
        var that = this;
        this.leftLoading = true;
        this.nowCheckOneId = 0;
        console.info(this.leftTreeTableId + "====" + this.leftTreePageId);
        var toHtData = {};
        toHtData.tableId = this.leftTreeTableId;
        toHtData.pageId = this.leftTreePageId;
        toHtData.ifAjax = 1;
        //判断是否有过滤条件 或者 已选中排前面的条件 如果有 则传递到后台去 &valuePlug_27=1,20,21,22,23&orderDataId=1,24,25
        var tmpJsonData = this.tmpJsonData;
        console.log("tmpJsonData===================",tmpJsonData);
        
        if(tmpJsonData != null && tmpJsonData.length > 0) {
            var tmpJsonDataArr = tmpJsonData.split("&");
            for (let index = 0; index < tmpJsonDataArr.length; index++) {
                const element = tmpJsonDataArr[index];
                console.log("element=================",element);
                
                var elementArr = element.split("=");
                if(elementArr.length > 1) {
                    toHtData[elementArr[0]] = elementArr[1];
                }
            }
        }

        var url = "/treeDialog_ajaxList.do";
        //进行后台数据搜索
        this.$axios.post(url,toHtData).then(res => {
            //关闭遮罩层
            that.leftLoading = false;
            //赋值当前页的数据进行页面显示
            //进行页面数据处理 组合成为树形结构
            var tmpTrr = utils.buildTree(res.data);
            console.log("tmpTrr===================",tmpTrr);
            that.leftTreeData = tmpTrr;
            if(that.initCheckKeyId != null && that.initCheckKeyId.length > 0) {
                var initCheckKeyArr = that.initCheckKeyId.split(",");
                this.$refs.oneTree.setCheckedKeys(initCheckKeyArr);
            }
            
        }).catch(error => {
            console.log("=====" + error);
        })
    },
    /**
     * 展开所有的树形节点
     */
    leftTreeOpen() {
        this.leftTreeIfOpen = true;
    },
    /**
     * 收起所有的树形节点
     */
    leftTreeClose() {
        this.leftTreeIfOpen = false;
    },
    /**
     * 进行树形节点的搜索
     */
    filterNode(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
    }
  },
  watch: {
    /**
     * 监控搜索的输入状态 调用树搜索
     */
    filterText(val) {
        this.$refs.oneTree.filter(val);
    }
  },
  beforeMount : function(){
      this.treeGetData();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
